'use client'

import {MantineProvider, Notifications} from '@blocks'
import {getTheme} from '@constants'
import type {ReactNode} from 'react'

type Payload = Readonly<{
   children: ReactNode
}>

export const AppProviders = ({children}: Payload) => {
   return (
      <MantineProvider
         defaultColorScheme={'light'}
         forceColorScheme={'light'}
         theme={getTheme()}
      >
         <Notifications
            position={'top-right'}
            limit={3}
         />
         {children}
      </MantineProvider>
   )
}
